var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-340 -16) translate(340 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#18191D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#83858C",
    d: "M10.947 20.579c-.54.008-.937.548-.947.947v8.842c0 .496.451.948.947.948h3.158c.496 0 .948-.452.948-.948v-8.842c0-.496-.452-.947-.948-.947h-3.158zm12.632-2.526c-.541.008-.937.548-.947.947v11.368c0 .496.45.948.947.948h3.158c.496 0 .947-.452.947-.948V19c0-.496-.451-.947-.947-.947h-3.158zm-6.316-2.527c-.54.009-.937.549-.947.948v13.894c0 .496.451.948.947.948h3.158c.496 0 .947-.452.947-.948V16.474c0-.496-.45-.948-.947-.948h-3.158zM29.895 13c-.541.008-.937.548-.948.947v16.421c0 .496.452.948.948.948h3.158c.496 0 .947-.452.947-.948v-16.42c0-.497-.451-.948-.947-.948h-3.158z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.ffc6b8c91a507fccc9e56c194b25a6e6.svg";
export { ForwardRef as ReactComponent };